import i18next from 'i18next'
import {memo, useEffect, useState} from 'react'
import Select, {SingleValue} from 'react-select'

interface SelectPageSizeProps {
  initialValue?: number
  onChange: (value: SingleValue<{label: string; value: number}>) => void
}

const intialOptions: {label: string; value: number}[] = [
  {label: `Tampilkan 5`, value: 5},
  {label: `Tampilkan 10`, value: 10},
  {label: `Tampilkan 25`, value: 25},
  {label: `Tampilkan 50`, value: 50},
  {label: `Tampilkan 100`, value: 100},
  {label: `Tampilkan 500`, value: 500},
]

// eslint-disable-next-line react/display-name
export const SelectPageSize = memo((props: SelectPageSizeProps) => {
  const [options, setOptions] = useState(intialOptions)

  useEffect(() => {
    if (i18next.language === 'en') {
      setOptions(
        options.map((o) => {
          o.label = o.label.replace('Tampilkan', 'Show')
          return o
        })
      )
    } else {
      setOptions(
        options.map((o) => {
          o.label = o.label.replace('Show', 'Tampilkan')
          return o
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18next.language])

  return (
    <Select
      styles={{
        container: (base: any) => ({...base, padding: '0 !important', maxWidth: 160, minWidth: 150}),
        menuPortal: (base: any) => ({...base, zIndex: 1000}),
        control: (base: any) => ({
          ...base,
          color: 'black',
          borderWidth: 2,
          borderRadius: 6,
          borderColor: '#d9dce4',
          textAlign: 'left',
          maxWidth: 160,
        }),
      }}
      options={options}
      defaultValue={options.find((option) => option.value === (props.initialValue ?? 25))}
      onChange={(value: any) => props.onChange(value)}
    />
  )
})
